




















































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState(['linkDownloadApp', 'linkSettings'])
  },
})
export default class DownloadAppModal extends Vue {
  linkDownloadApp!: string;
  linkSettings!: string;

  mounted() {
    // Отсутствует аннотация типов для этой библиотеки
    // eslint-disable-next-line
    const QRCode = require('qrcode-compact-svg');
    const qrDownloadApp = new QRCode(this.linkDownloadApp);
    const qrSettings = new QRCode(this.linkSettings);
    const qrDivDownloadApp = document.getElementById('qrDownloadApp');
    const qrDivSettings = document.getElementById('qrSettings');
    if (qrDivDownloadApp) {
      qrDivDownloadApp.innerHTML = qrDownloadApp.svg();
    }
    if (qrDivSettings) {
      qrDivSettings.innerHTML = qrSettings.svg();
    }
  }

  toDownloadLink() {
    window.open(this.linkDownloadApp, '_blank');
  }
}
